import React from 'react';
import Imgix from 'react-imgix';
import { Link } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';
import { H4, SubtitleThree } from '../../../../styles/theme/default/typography';

const Wrapper = styled.div`
  .shop-now-link,
  .copy-text-link {
    &:hover {
      text-decoration: none;
    }
  }

  .copy-text {
    max-width: 320px;
    margin-top: 15px;
    transition: color 0.25s;
    &:hover {
      transition: color 0.25s;
      color: #3a5bb2;
    }
  }
  .copy-text-smaller {
    max-width: 400px;
    margin-top: 15px;
    transition: color 0.25s;
    font-size: 27px;
    &:hover {
      transition: color 0.25s;
      color: #3a5bb2;
    }
  }
  .shop-now {
    .underline-image {
      width: 88px;
      height: auto;
    }

    .trade-underline-image {
      width: 240px;
      height: auto;
    }

    padding-bottom: 5px;
    transition: color 0.25s;

    .not-hovered {
      display: block;
    }
    .hovered {
      display: none;
    }

    &:hover {
      .not-hovered {
        display: none;
      }
      .hovered {
        display: block;
      }
      text-decoration: none;
      transition: color 0.25s;
      color: #245caf;
    }
  }
`;

function ImageModule({ image, copy, url, trade, smallerCopy, customImgixParameters }) {
  const theme = useTheme();

  return (
    <Wrapper>
      <ImageContainer>
        <Link to={url}>
          <Imgix
            className="nav-image"
            imgixParams={{ auto: 'compress,format', fit: 'crop', crop: 'bottom', ar:'2:1', ...customImgixParameters }}
            sizes="
                  (min-width: 1200px) 330px,
                  (min-width: 1100px) 230px,
                  330px"
            src={image}
            htmlAttributes={{
              alt: 'nav-image'
            }}
          />
        </Link>
      </ImageContainer>
      <Link to={url} className="copy-text-link">
        {/*{smallerCopy ? <h5 className="copy-text">{copy}</h5> : <h4 className="copy-text">{copy}</h4>}*/}
        <H4 className={smallerCopy ? 'copy-text-smaller' : 'copy-text'}>{copy}</H4>
      </Link>
      <Link to={url} className="shop-now-link">
        <SubtitleThree as="span" className="shop-now">
          <Underline>{trade ? 'Apply Now' : 'Shop Now'}</Underline>
        </SubtitleThree>
      </Link>
    </Wrapper>
  );
}

export default ImageModule;

const ImageContainer = styled.div`
  width: 320px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-bottom: 56.25%;
  overflow: hidden;

  a {
    position: absolute !important;
    top: 0;
    left: 0;
    background: white;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    overflow: hidden;

    .nav-image {
      transition: all 0.5s ease;
      position: absolute;
      max-width: 100%;
      max-height: 100%;
      height: 100%;
      width: auto;

      &:hover {
        transform: scale(1.1);
      }
    }
  }

  @media (max-width: 992px) {
    width: 220px;
  }
`;

const Underline = styled.span`
  text-decoration: ${({ theme }) => theme.old ? 'none' : 'underline'};
`;
